/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC as ReactFC } from 'react';

import * as intl from 'react-intl-universal';

import ModulePaths from 'constants/ModulePaths';
import { getCompactNumber, getFormattedNumber } from 'helpers/NumberFormat';
import LoanFundUtilizationProps from 'modules/private/dashboard/components/financial-metrics/loan-fund-utilization/LoanFundUtilizationProps';
import InsLink from 'shared/components/ins-link/InsLink';

import LineChart from '../../line-chart/LineChart';

const LoanFundUtilization: ReactFC<LoanFundUtilizationProps> = (props) => {
  const { data, xAxisConfig, filters, meta } = props;

  /**
   * Formats tick values
   *
   * @param value Tick value
   * @returns {string} Formatted tick value
   */
  const formatNumber = (value: any): string =>
    `${getCompactNumber(Number(value), true)}%`;

  const sliceRenderer = (value): string =>
    `${getFormattedNumber(Number(value), true)}%`;

  const legendLabelRenderer = (): string =>
    intl.get('LBL_LOAN_FUND_UTILIZATION_1');

  const renderChartLegend = (): JSX.Element => (
    <div className="chart-legend inline">
      <div className="item">
        <span className="color" style={{ backgroundColor: '#68C7C2' }} />
        <span className="label">
          <span className="name">
            {intl.get('LBL_LOAN_FUND_UTILIZATION_1')}
          </span>
        </span>
      </div>
      <div className="item">
        <span className="color" style={{ backgroundColor: '#F8E9C5' }} />
        <span className="label">
          <span className="name">{`${intl.get(
            'LBL_LOAN_FUND_UTILIZATION_1'
          )} ${String(filters.timeUnit.label)}`}</span>
        </span>
      </div>
    </div>
  );

  return (
    <>
      <LineChart
        data={data}
        meta={meta}
        xAxisConfig={xAxisConfig}
        filters={filters}
        tickFormatter={formatNumber}
        sliceRenderer={sliceRenderer}
        legendLabelRenderer={legendLabelRenderer}
      />
      <div className="chart-footer">
        {renderChartLegend()}
        <span className="chart-overview">
          <InsLink
            disabledClass="disabled"
            to={ModulePaths.FinancesPath}
            className="btn btn-secondary btn-sm"
          >
            <i className="icon-arrow-right" /> {intl.get('BTN_FINANCES_PAGE')}
          </InsLink>
        </span>
      </div>
    </>
  );
};

export default LoanFundUtilization;
